export default function returnZeroIfEmpty(myString) {
    if(myString === "")
    {
      return '0';
    }
    else{
    return myString;
    }
  }